module.exports = __webpack_public_path__ + "static/media/Xing.df6f7061.svg";